export const API_REGISTRY_CONSTANTS = {
    SEND_NOTIFY_MAIL: '667920261a0f9a6cbdb8477c',
    SEND_NOTIFY_MAIL_TO_USER: '667920261a0f9a6cbdb8477c',
    SEND_NOTIFY_MAIL_TO_ASSIGNEE: '667e44c8a4f77b1a37f565ab',
    VALIDATE_GST: '66e2e10d623e781ee36cc6a4',
    VALIDATE_GST_NODE: '66e4018c2a52d41e8b7b1ba6',
    VALIDATE_PAN: '66e2e2cb623e781ee36cd326',
    VALIDATE_PAN_NODE: '66e403452a52d41e8b7b24ea',
};
